// @flow
// Initial States
import { initialState as auth } from 'hfty-auth'
import { initialState as userData } from 'hfty-users/src/initialState'
import { initialState as assetData } from 'hfty-assets'
import { initialState as assetsModule } from 'hfty-assets-dom'
import { initialState as navigation } from 'hfty-navigation-web'
import { initialState as mapModule } from 'hfty-map'

import type {
  State,
} from './types'

export default ({
  auth,
  userData,
  assetData,
  assetsModule,
  navigation,
  mapModule,
}: State)
